import axios from 'axios'
// const BASE = 'http://localhost:8022/api/'
//const BASE = 'https://devapis.anubys.cl:8038/api/'
const BASE = 'https://api.comunaconectada.com/api/'
/* const BASE = 'https://devapis.anubys.cl:8040/api' */

const service = axios.create({ baseURL: BASE })

service.defaults.timeout = 10000

service.interceptors.request.use(
  config => {
    const contentType = config.data instanceof FormData ? 'multipart/form-data':'application/json'
    const token = localStorage.getItem('userTokenSOSDenuncias')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    config.headers['Content-Type'] = contentType
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers['company-id'] = 1
    return config
  },
  error => {
    console.log("API: ", error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      if (response.status === 403 || response.status === 50008 || response.status === 50012 || response.status === 50014) {
        localStorage.removeItem('userTokenSOSDenuncias')
        // location.reload()
      }
      return Promise.reject(response || 'Error')
    } else {
      return response.data
    }
  },
  async error => {
    if(error.response && (error.response.status === 403 || error.response.status === 401)){
      await localStorage.removeItem('userTokenSOSDenuncias')
			return Promise.resolve(error.response)
    }
    if(error.response && (error.response.status === 404)){
			return Promise.resolve(error.response)
		}
    return Promise.reject(error)
  }
)

export default service